import * as React from "react";
import { forwardRef, memo } from "react";
const SvgToolbar = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120zm0-520h560v-120H200zm560 80H200v360h560zm-560-80v80zm0 0v-120zm0 80v360z" })));
const ForwardRef = forwardRef(SvgToolbar);
const Memo = memo(ForwardRef);
export default Memo;
